"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.icon = exports.copyButtonSpan = exports.button = void 0;
var widgets_1 = require("@tableau/widgets");
var button = {
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    paddingLeft: widgets_1.TabStyles.Spacing.SmallSpace,
    paddingRight: widgets_1.TabStyles.Spacing.SmallSpace,
};
exports.button = button;
var copyButtonSpan = {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
};
exports.copyButtonSpan = copyButtonSpan;
var icon = {
    marginRight: widgets_1.TabStyles.Spacing.DefaultSpace,
};
exports.icon = icon;
//# sourceMappingURL=CopyButtonStyle.js.map